import { holdsAny, ROLES } from "../lib/access";

export type OnboardingWorkspace = "administration" | "participant";

export function onboardingRoot(workspace: OnboardingWorkspace): string {
  return workspace === "participant" ? "/inbox/tasks/onboarding" : "/onboarding";
}

/** Existing participant bookmarks reach the task workspace before the admin route gate. */
export function participantOnboardingRedirect(
  pathname: string,
  roles: readonly string[],
): string | null {
  if (holdsAny(roles, ROLES.onboarding)) return null;
  const root = onboardingRoot("participant");
  if (pathname === "/onboarding") return `${root}/support`;
  for (const section of ["support", "reviews", "final-reviews"]) {
    const old = `/onboarding/${section}`;
    if (pathname === old || pathname.startsWith(`${old}/`)) {
      return `${root}/${section}${pathname.slice(old.length)}`;
    }
  }
  return null;
}
